import type { TableReservationVO } from "@/api/business/types/table"
import type { SMSConfigTuple, SMSTypeInfoDTO } from "@/api/setting/type/setting"
import { createTableReservation } from "@/api/business/table"

export type ReservationSubmitIntent = "reservation" | "reservation-and-sms"
export type ReservationSmsStatus = "NOT_REQUESTED" | "SUBMITTED" | "SENT" | "FAILED"

export interface ReservationSubmissionResult {
  code: number
  data?: boolean
  msg?: string
  reservationCreated?: boolean
  reserveIds?: number[]
  smsStatus: ReservationSmsStatus
  smsCode?: string | null
  smsMessage?: string | null
  templateCode?: string
}

const RESERVATION_SMS_TYPE = {
  member: {
    typeKey: "member.reservation",
    scene: "会员预订",
  },
  customer: {
    typeKey: "customer.reservation",
    scene: "非会员预订",
  },
} as const

export function isReservationSmsAvailable(
  config: SMSConfigTuple | null | undefined,
  messageTypes: readonly SMSTypeInfoDTO[] | null | undefined,
  isMemberReservation: boolean,
): boolean {
  const remainingQuota = Number(config?.remainingSmsQuota)
  if (config?.status !== 1 || !Number.isFinite(remainingQuota) || remainingQuota <= 0) {
    return false
  }

  const expectedType = isMemberReservation
    ? RESERVATION_SMS_TYPE.member
    : RESERVATION_SMS_TYPE.customer
  const messageType = messageTypes?.find(item =>
    item.typeKey === expectedType.typeKey
    || (!item.typeKey && item.scene === expectedType.scene),
  )
  return messageType?.status === 1
}

export async function submitNewReservation(
  params: TableReservationVO,
  intent: ReservationSubmitIntent,
): Promise<ReservationSubmissionResult> {
  const response = await createTableReservation(params)
  return {
    ...response,
    smsStatus: intent === "reservation-and-sms" ? "SUBMITTED" : "NOT_REQUESTED",
  }
}

export function getReservationSubmitSuccessMessage(
  result: Pick<ReservationSubmissionResult, "code" | "smsStatus" | "smsMessage">,
): string {
  if (result.smsStatus === "SUBMITTED") {
    return "预订成功，短信通知已提交"
  }
  if (result.smsStatus === "SENT") {
    return "预订成功并发送短信"
  }
  if (result.smsStatus === "FAILED") {
    return `预订成功，但短信发送失败：${result.smsMessage || "未知原因"}`
  }
  return "新增预订成功"
}
